var render = function () {
  var _obj,
    _obj$1,
    _obj$2,
    _obj$3,
    _obj$4,
    _obj$5,
    _obj$6,
    _obj$7,
    _obj$8,
    _obj$9,
    _obj$10
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "filter-search-form note note-info note-bordered margin-bottom-20",
    },
    [
      _c("div", { staticClass: "row margin-bottom-20" }, [
        _c("div", { staticClass: "col-md-9" }, [
          _c("div", { staticClass: "col-md-9" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("label", { staticClass: "filtro-label-avancado" }, [
                  _vm._v("Perfil de Filtros"),
                ]),
                _vm._v(" "),
                _c("wes-Lookup", {
                  ref: "lookupPerfil",
                  attrs: {
                    entityName: "FN_GERENCIAISPERFIS",
                    resultFields: "NOME",
                    whereClauseSessionKey: "lookupPerfilOrcamentoWhere",
                    placeholders: _vm.getPlaceHoldersPerfil(),
                    enabled: _vm.isTreeViewLoaded(),
                  },
                  on: {
                    change: _vm.selecionarPerfil,
                    mounted: _vm.limparPerfilSelecionado,
                    clear: _vm.limparPerfilSelecionado,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "filtro-gerenciais-right-actions col-md-3",
              on: { click: _vm.actionsClick },
            },
            [
              _c("label", { staticClass: "filtro-label-avancado" }, [
                _vm._v("Período"),
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _vm.isDateError
                  ? _c("span", { staticClass: "badge badge-danger" }, [
                      _vm._v(
                        "\n                            Data inicial deve ser menor que data final\n                        "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("wes-date-range-button", {
                key: "t1",
                attrs: {
                  gerarEnabled: _vm.isTreeViewLoaded(),
                  startView: "0",
                  buttonDescription: "Gerar",
                  startDate: _vm.getMinDate(),
                  endDate: _vm.getMaxDate(),
                },
                on: {
                  "error-input": _vm.onErrorDateRange,
                  apply: _vm.applyFilter,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row collapse in", attrs: { id: "filtro-body" } },
        [
          _c(
            "div",
            { staticClass: "col-md-3", staticStyle: { "min-height": "300px" } },
            [
              _c(
                "ul",
                { staticClass: "nav nav-tabs tabs-left tabbable-line" },
                [
                  _c("li", { staticClass: "active" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "#treeview_empresaFilial",
                          "data-toggle": "tab",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-building" }),
                        _vm._v(" Empresa e Filiais "),
                        _vm.getTotalSelectedEmpresaFilial() > 0 &&
                        !_vm.isEmpresaTreeViewLoading()
                          ? _c("span", { staticClass: "badge badge-default" }, [
                              _vm._v(
                                _vm._s(_vm.getTotalSelectedEmpresaFilial())
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-fade" } }, [
                          _vm.isEmpresaTreeViewLoading()
                            ? _c("span", {
                                staticClass: "fa fa-spinner fa-spin",
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-fade" } }, [
                          _vm.isEmpresaMissing
                            ? _c(
                                "span",
                                { staticClass: "badge badge-danger" },
                                [_vm._v(" selecione ")]
                              )
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "pulsate-regular" }, [
                    _c(
                      "a",
                      {
                        class: {
                          "not-active":
                            _vm.isContaTreeViewLoading() ||
                            !_vm.isContaEmpresaMestreRegra(),
                        },
                        attrs: {
                          href: "#treeview_contas",
                          "data-toggle": "tab",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-bank" }),
                        _vm._v(" Contas "),
                        _vm.getTotalSelectedContas() > 0 &&
                        !_vm.isContaTreeViewLoading()
                          ? _c("span", { staticClass: "badge badge-default" }, [
                              _vm._v(_vm._s(_vm.getTotalSelectedContas())),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-fade" } }, [
                          _vm.isContaTreeViewLoading()
                            ? _c("span", {
                                staticClass: "fa fa-spinner fa-spin",
                              })
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "a",
                      {
                        class: { "not-active": _vm.notActiveCCRules() },
                        attrs: { href: "#treeview_cc", "data-toggle": "tab" },
                      },
                      [
                        _c("i", { staticClass: "fa fa-money" }),
                        _vm._v(" CC "),
                        _vm.getTotalSelectedCC() > 0 &&
                        !_vm.isCCTreeViewLoading()
                          ? _c("span", { staticClass: "badge badge-default" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.getTotalSelectedCC()) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-fade" } }, [
                          _vm.isCCTreeViewLoading()
                            ? _c("span", {
                                staticClass: "fa fa-spinner fa-spin",
                              })
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "a",
                      {
                        class: {
                          "not-active": !_vm.isProjetoEmpresaMestreRegra(),
                        },
                        attrs: {
                          href: "#treeview_projetos",
                          "data-toggle": "tab",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-line-chart" }),
                        _vm._v(" Projetos "),
                        _vm.getTotalSelectedProjetos() > 0 &&
                        !_vm.isProjetoTreeViewLoading()
                          ? _c("span", { staticClass: "badge badge-default" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getTotalSelectedProjetos()) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("transition", { attrs: { name: "slide-fade" } }, [
                          !_vm.isProjetoEmpresaMestreRegra()
                            ? _c("span", {
                                staticClass: "fa fa-spinner fa-spin",
                              })
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._m(2),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-9" }, [
            _c("div", { staticClass: "tab-content" }, [
              _c(
                "div",
                {
                  staticClass: "tab-pane active",
                  attrs: { id: "treeview_empresaFilial" },
                },
                [
                  _c("wes-treeview", {
                    key: _vm.chaveUnicaPerfilSelecionado + "-1",
                    attrs: {
                      store: _vm.getTreeViewEmpresaFilial(),
                      "treeview-id": "empresaFilial",
                      button: "circle",
                      endpoint: "empresaFilialSelecionadaAutorizada",
                      markAllByDefault: true,
                    },
                    on: {
                      "item-selected": function ($event) {
                        return _vm.itemSelected(
                          $event,
                          _vm.tabInfo.empresaFilial
                        )
                      },
                      loaded: _vm.setTotalTreeViews,
                      unloaded: _vm.setUnloadedTreeView,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane fade",
                  attrs: { id: "treeview_contas" },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("wes-treeview-select", {
                          key: _vm.chaveUnicaPerfilSelecionado + "-2",
                          ref: "treeviewSelectContas",
                          attrs: {
                            store: _vm.getTreeViewContas(),
                            "treeview-id": "contas",
                            definitions: _vm.contaDefinitions,
                          },
                          on: {
                            "menu-item-selected": _vm.menuItemSelected,
                            "lookup-item-selected": _vm.lookupItemSelected,
                            "item-selected": function ($event) {
                              return _vm.itemSelected(
                                $event,
                                _vm.tabInfo.contas
                              )
                            },
                            "tree-view-loaded": _vm.setTotalTreeViews,
                            "tree-view-unloaded": _vm.setUnloadedTreeView,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tab-pane fade", attrs: { id: "treeview_cc" } },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("label", { staticClass: "label-title" }, [
                          _vm._v(
                            "Exibir lançamentos sem Centros de Custos informados (NI)"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("wes-switch", {
                          attrs: { value: _vm.getExibirCentrosCustoNulos() },
                          on: { change: _vm.exibirCentrosCustoNulosChanged },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-md-6",
                        staticStyle: { "padding-top": "10px" },
                      },
                      [
                        _c("wes-treeview-select", {
                          key: _vm.chaveUnicaPerfilSelecionado + "-3",
                          ref: "treeviewSelectCC",
                          attrs: {
                            store: _vm.getTreeViewCentroDeCustos(),
                            markAllByDefault: true,
                            "treeview-id": "CC",
                            definitions: _vm.ccDefinitions,
                          },
                          on: {
                            "menu-item-selected": _vm.menuItemSelected,
                            "lookup-item-selected": _vm.lookupItemSelected,
                            "item-selected": function ($event) {
                              return _vm.itemSelected(
                                $event,
                                _vm.tabInfo.centroDeCustos
                              )
                            },
                            "tree-view-loaded": _vm.setTotalTreeViews,
                            "tree-view-unloaded": _vm.setUnloadedTreeView,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane fade",
                  attrs: { id: "treeview_projetos" },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("label", { staticClass: "label-title" }, [
                          _vm._v(
                            "Exibir lançamentos sem Projetos informados (NI)"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("wes-switch", {
                          attrs: { value: _vm.getExibirProjetosNulos() },
                          on: { change: _vm.exibirProjetosNulosChanged },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(3),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane fade",
                  staticStyle: { "padding-top": "10px" },
                  attrs: { id: "treeview_avancado" },
                },
                [
                  _c("label", { staticClass: "filtro-label-avancado" }, [
                    _vm._v("Origem do realizado"),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-circle btn-xs",
                        class:
                          ((_obj = {}),
                          (_obj[_vm.colorSelected] =
                            _vm.isOrigemRealizadoEnabled(0)),
                          (_obj[_vm.colorDeselected] =
                            !_vm.isOrigemRealizadoEnabled(0)),
                          _obj),
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function ($event) {
                            return _vm.selectOrigemRealizado(0)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-money" }),
                        _vm._v(" Financeiro\n                            "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-circle btn-xs",
                        class:
                          ((_obj$1 = {}),
                          (_obj$1[_vm.colorSelected] =
                            _vm.isOrigemRealizadoEnabled(1)),
                          (_obj$1[_vm.colorDeselected] =
                            !_vm.isOrigemRealizadoEnabled(1)),
                          _obj$1),
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function ($event) {
                            return _vm.selectOrigemRealizado(1)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-calculator" }),
                        _vm._v(" Contabil\n                            "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "slide-fade" } }, [
                    _vm.isOrigemRealizadoEnabled(0)
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-circle btn-xs",
                              class:
                                ((_obj$2 = {}),
                                (_obj$2[_vm.colorSelected] =
                                  _vm.isTipoOrcamentoEnabled(0)),
                                (_obj$2[_vm.colorDeselected] =
                                  !_vm.isTipoOrcamentoEnabled(0)),
                                _obj$2),
                              attrs: { href: "javascript:;" },
                              on: {
                                click: function ($event) {
                                  return _vm.selectTipoOrcamentoEnabled(0)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-bank" }),
                              _vm._v(
                                " Visão econômica\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-circle btn-xs",
                              class:
                                ((_obj$3 = {}),
                                (_obj$3[_vm.colorSelected] =
                                  _vm.isTipoOrcamentoEnabled(1)),
                                (_obj$3[_vm.colorDeselected] =
                                  !_vm.isTipoOrcamentoEnabled(1)),
                                _obj$3),
                              attrs: { href: "javascript:;" },
                              on: {
                                click: function ($event) {
                                  return _vm.selectTipoOrcamentoEnabled(1)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-money" }),
                              _vm._v(
                                " Visão financeira\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticClass: "filtro-label-avancado" },
                            [_vm._v("Data do realizado financeiro")]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-circle btn-xs",
                                class:
                                  ((_obj$4 = {}),
                                  (_obj$4[_vm.colorSelected] =
                                    _vm.isDataRealizadoFinanceiro(0)),
                                  (_obj$4[_vm.colorDeselected] =
                                    !_vm.isDataRealizadoFinanceiro(0)),
                                  _obj$4),
                                attrs: { href: "javascript:;" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectDataRealizadoFinanceiro(0)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-calendar-minus-o",
                                }),
                                _vm._v(
                                  " Vencimento\n                                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-circle btn-xs",
                                class:
                                  ((_obj$5 = {}),
                                  (_obj$5[_vm.colorSelected] =
                                    _vm.isDataRealizadoFinanceiro(1)),
                                  (_obj$5[_vm.colorDeselected] =
                                    !_vm.isDataRealizadoFinanceiro(1)),
                                  _obj$5),
                                attrs: { href: "javascript:;" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectDataRealizadoFinanceiro(1)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-calendar-check-o",
                                }),
                                _vm._v(
                                  " Pagamento (todos)\n                                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-circle btn-xs",
                                class:
                                  ((_obj$6 = {}),
                                  (_obj$6[_vm.colorSelected] =
                                    _vm.isDataRealizadoFinanceiro(2)),
                                  (_obj$6[_vm.colorDeselected] =
                                    !_vm.isDataRealizadoFinanceiro(2)),
                                  _obj$6),
                                attrs: { href: "javascript:;" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectDataRealizadoFinanceiro(2)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "fa fa-calendar" }),
                                _vm._v(
                                  " Pagamento (tesouraria)\n                                    "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("hr"),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "filtro-label-avancado" }, [
                    _vm._v("Percentuais"),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-circle btn-xs",
                        class:
                          ((_obj$7 = {}),
                          (_obj$7[_vm.colorSelected] =
                            _vm.isPercentuaisEnabled(0)),
                          (_obj$7[_vm.colorDeselected] =
                            !_vm.isPercentuaisEnabled(0)),
                          _obj$7),
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function ($event) {
                            return _vm.selectPercentuais(0)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-percent" }),
                        _vm._v(
                          " (Realizado/Orçado)\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-circle btn-xs",
                        class:
                          ((_obj$8 = {}),
                          (_obj$8[_vm.colorSelected] =
                            _vm.isPercentuaisEnabled(1)),
                          (_obj$8[_vm.colorDeselected] =
                            !_vm.isPercentuaisEnabled(1)),
                          _obj$8),
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function ($event) {
                            return _vm.selectPercentuais(1)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-percent" }),
                        _vm._v(
                          " (Realizado/Orçado)-100\n                            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("label", { staticClass: "filtro-label-avancado" }, [
                    _vm._v("Fórmula saldo"),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-circle btn-xs",
                        class:
                          ((_obj$9 = {}),
                          (_obj$9[_vm.colorSelected] =
                            _vm.isFormulaSaldoEnabled(0)),
                          (_obj$9[_vm.colorDeselected] =
                            !_vm.isFormulaSaldoEnabled(0)),
                          _obj$9),
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function ($event) {
                            return _vm.selectFormulaSaldo(0)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa fa-calculator" }),
                        _vm._v(
                          " Orçado - Realizado\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-circle btn-xs",
                        class:
                          ((_obj$10 = {}),
                          (_obj$10[_vm.colorSelected] =
                            _vm.isFormulaSaldoEnabled(1)),
                          (_obj$10[_vm.colorDeselected] =
                            !_vm.isFormulaSaldoEnabled(1)),
                          _obj$10),
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function ($event) {
                            return _vm.selectFormulaSaldo(1)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa fa-calculator" }),
                        _vm._v(
                          " Realizado - Orçado\n                            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _vm.exibeFiltrosDoOrcamentoPublico
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "row filtros-orcamento-grade" },
                          [
                            _c("div", { staticClass: "col-md-6" }, [
                              _c(
                                "label",
                                { staticClass: "filtro-label-avancado" },
                                [_vm._v("Tipo de gastos")]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  ref: "tipoGasto",
                                  staticClass: "form-control",
                                },
                                [
                                  _c("option", { attrs: { value: "" } }),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v("Governamental"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "2" } }, [
                                    _vm._v("Institucional"),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "3" } }, [
                                    _vm._v("Operacional"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("hr"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6" }),
                            _vm._v(" "),
                            _vm._l(_vm.lookupItems, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "col-md-6" },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "filtro-label-avancado" },
                                    [_vm._v(_vm._s(item.label))]
                                  ),
                                  _vm._v(" "),
                                  _c("wes-lookup-multiple", {
                                    ref: item.ref,
                                    refInFor: true,
                                    attrs: {
                                      entityName: item.entityName,
                                      resultFields: "NOME",
                                      placeholders: _vm.getPlaceHoldersCustom(
                                        item.label
                                      ),
                                      enabled: _vm.isTreeViewLoaded(),
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.selecionarLookupAvancado(
                                          item,
                                          $event
                                        )
                                      },
                                      clear: function ($event) {
                                        return _vm.selecionarLookupAvancado(
                                          item,
                                          []
                                        )
                                      },
                                      mounted: function ($event) {
                                        return _vm.lookupAvancadoMontado(item)
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("hr"),
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.camposExtras, function (campo) {
                              return _c(
                                "div",
                                { key: campo.nome, staticClass: "col-md-6" },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "filtro-label-avancado" },
                                    [_vm._v(_vm._s(campo.titulo))]
                                  ),
                                  _vm._v(" "),
                                  campo.tipo === "Lookup"
                                    ? _c("wes-lookup-multiple", {
                                        ref: _vm.refDoCampoExtra(campo),
                                        refInFor: true,
                                        attrs: {
                                          entityName: campo.lookupEntidade,
                                          resultFields:
                                            campo.lookupCampoResultado,
                                          placeholders:
                                            _vm.getPlaceHoldersCustom(
                                              campo.titulo
                                            ),
                                          enabled: _vm.isTreeViewLoaded(),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.selecionarCampoExtra(
                                              campo,
                                              $event
                                            )
                                          },
                                          clear: function ($event) {
                                            return _vm.selecionarCampoExtra(
                                              campo,
                                              []
                                            )
                                          },
                                        },
                                      })
                                    : _c(
                                        "select",
                                        {
                                          ref: _vm.refDoCampoExtra(campo),
                                          refInFor: true,
                                          staticClass:
                                            "mt-multiselect form-control select2-lookup-multiple",
                                          attrs: { multiple: "" },
                                        },
                                        _vm._l(campo.itens, function (item) {
                                          return _c(
                                            "option",
                                            {
                                              key: item.valor,
                                              domProps: { value: item.valor },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(item.texto) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                  _vm._v(" "),
                                  _c("hr"),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "slide-fade" } }, [
                    _vm.isOrigemRealizadoEnabled(1)
                      ? _c("div", [
                          _c(
                            "label",
                            { staticClass: "filtro-label-avancado" },
                            [_vm._v("Considerar Comprometido")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("wes-switch", {
                                attrs: { value: _vm.isConsideraComprometido() },
                                on: {
                                  change: _vm.consideraComprometidoChanged,
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane fade",
                  staticStyle: { "padding-top": "10px" },
                  attrs: { id: "treeview_perfil" },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Nome do perfil")]),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "form-control",
                          attrs: { type: "text", id: "nomePerfil" },
                          domProps: { value: _vm.nomePerfil },
                          on: { input: _vm.setNomePerfil },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-actions" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-info",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.persistirPerfil()
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "fa fa-save" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.isPerfilSistema()
                                      ? "Salvar cópia de perfil pré-definido"
                                      : "Salvar perfil"
                                  ) +
                                  "\n                                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.perfilSelecionado() && !_vm.isPerfilSistema()
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn btn-danger",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.excluirPerfil()
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fa fa-times" }),
                                  _vm._v(
                                    " Excluir perfil\n                                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-md-3 filtro-gerenciais-actions collapsible",
        attrs: {
          "data-toggle": "collapse",
          "data-parent": "false",
          "data-target": "#filtro-body",
        },
      },
      [
        _c("div", { staticStyle: { "padding-top": "20px" } }, [
          _c(
            "p",
            { staticStyle: { "font-size": "14px", "text-align": "right" } },
            [
              _vm._v("Filtro avançado "),
              _c("i", {
                staticClass: "fa fa-chevron-down font-black",
                staticStyle: { cursor: "pointer" },
                attrs: { title: "Clique para expandir o menu de filtros." },
              }),
            ]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "#treeview_avancado", "data-toggle": "tab" } }, [
        _c("i", { staticClass: "fa fa-gears" }),
        _vm._v(" Avançado\n                        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "#treeview_perfil", "data-toggle": "tab" } }, [
        _c("i", { staticClass: "fa fa-bookmark" }),
        _vm._v(" Perfil de Filtro\n                        "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12", staticStyle: { "padding-top": "10px" } },
        [
          _c("div", { attrs: { id: "treeview_projetos_custom" } }, [
            _c("div", { attrs: { id: "treeview_projetos_custom_filtro" } }),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }